// extracted by mini-css-extract-plugin
export default {"buttonPagination":"pagination_buttonPagination__UbxgQ"};